import { createQueryKeys } from '@lukemorales/query-key-factory';
import { useMutation, useQuery, UseQueryOptions } from '@tanstack/react-query';
import { SettingApi } from 'api';
import type { Setting } from 'api/methods/SettingApi';

/**
 * [Setting] Query key 생성
 * --
 */
export const settingQueryKeys = createQueryKeys('setting', {
  getSetting: (idx: number, params?: { [key: string]: string | number }) => [
    idx,
    params,
  ],
  getSettings: (params?: { [key: string]: string | number }) => [params],
});

/**
 * [Setting] 설정 전체 조회
 * --
 */
export const useGetSettings = (params?: { [key: string]: string | number }) => {
  const data = useQuery({
    queryKey: settingQueryKeys.getSettings(params).queryKey,
    queryFn: () => SettingApi.getSettings(params),
  });
  return data;
};

/**
 * [Setting] 설정 상세 조회
 * --
 */
export const useGetSetting = (
  idx: number,
  params?: { [key: string]: string | number },
  options?: UseQueryOptions<any, any>
) => {
  const data = useQuery({
    queryKey: settingQueryKeys.getSetting(idx, params).queryKey,
    queryFn: () => SettingApi.getSetting(idx, params),
    ...options,
  });

  return data;
};

/**
 * [Setting] 설정 생성
 * --
 */
export const useCreateSetting = (body: Setting) => {
  const { mutateAsync: createSetting, ...result } = useMutation({
    mutationFn: (variables: Setting) => SettingApi.createSetting(variables),
    onSuccess: (data, variables) => {
      console.log(data, variables);
    },
    onError: (error) => {
      console.error(error);
    },
  });

  return { createSetting, ...result };
};

/**
 * [Setting] 설정 수정
 * --
 */
export const useUpdateSetting = (body: Setting) => {
  const { mutateAsync: updateSetting, ...result } = useMutation({
    mutationFn: (variables: Setting) => SettingApi.updateSetting(variables),
    onSuccess: (data, variables) => {
      console.log(data, variables);
    },
    onError: (error) => {
      console.error(error);
    },
  });

  return { updateSetting, ...result };
};

/**
 * [Setting] 설정 삭제
 * --
 */
export const useDeleteSetting = (idx: number) => {
  const { mutateAsync: deleteSetting, ...result } = useMutation({
    mutationFn: (variables: number) => SettingApi.deleteSetting(variables),
    onSuccess: (data, variables) => {
      console.log(data, variables);
    },
    onError: (error) => {
      console.error(error);
    },
  });

  return { deleteSetting, ...result };
};
